<template>
  <div>
    <form @submit.prevent="search(vin)">
      <SfHeading :level="4" :title="$t('Search by VIN')" class="sf-heading--left" />
      <InputWithButton
        name="vin"
        v-model="vin"
        :placeholder="$t('Search by VIN')"
        :aria-label="$t('Search by VIN')"
        :button="{
          type: 'submit',
        }"
        >{{ $t('Submit') }}</InputWithButton
      >
    </form>
    <VinModal
      :visible="vinModalVisible"
      @close="vinModalVisible = false"
      :vehicles="vehicles"
      @select="selectVehicle"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { SfHeading } from '@storefront-ui/vue';
import { InputWithButton } from '@/modules/core';

import VinModal from '../modals/VinModal.vue';

export default {
  name: 'Level4Forms',
  components: {
    SfHeading,
    InputWithButton,
    VinModal,
  },
  created() {
    this.vin = this.vehicleData?.Vin ? this.vehicleData.VehicleInfo.vin7 : '';
  },
  data() {
    return {
      vin: '',
      vehicles: [],
      vinModalVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      vehicleData: 'level4/vehicleData',
    }),
  },
  watch: {
    vehicleData(newValue) {
      if (!newValue?.Vin) {
        this.vin = '';
      }
    },
  },
  methods: {
    ...mapActions({
      searchByVin: 'level4/searchByVin',
      setVin: 'level4/setVin',
    }),
    search(vin) {
      this.searchByVin(vin).then((data = []) => {
        if (data.length === 1) {
          this.setVin(data[0]);
        }

        if (data.length > 1) {
          this.vehicles = data;
          this.vinModalVisible = true;
        }
      });
    },
    selectVehicle(vehicle) {
      this.setVin(vehicle);
      this.vinModalVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@storefront-ui/shared/styles/helpers';
@import 'src/scss/_breakpoint';

.sf-heading {
  @include flexbox-desktop {
    margin-bottom: var(--spacer-sm);
  }
}

.sf-button--outline {
  --button-border-color: var(--_c-gray-secondary);
  --button-color: var(--_c-gray-secondary);
}
</style>
